const t = {
  ghost: "ghost",
  primary: "primary",
  secondary: "secondary",
  text: "text"
};
export {
  t as Variants
};
